<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="m-0">About Us</h2>
        </div>
    </div>
</div>

<section class="about-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span class="sub-title">About Us</span>
                    <h2>Embark on your journey to success with <span class="text-theme-optional">Kaims IT Services.</span></h2>
                    <p>
                        Welcome to <span class="text-theme-optional">Kaims IT Services</span>, where innovation meets
                        excellence in the world of IT services. As
                        a pioneering force in the industry, we specialize in delivering cutting-edge technology
                        solutions tailored to meet your unique business needs. Our team of skilled professionals
                        combines expertise with creativity to provide top-notch services, including software
                        development, web design, cloud solutions, and IT consulting. With a commitment to quality and
                        client satisfaction, we strive to exceed expectations, ensuring seamless integration of
                        technology into your operations. Join us on a journey of digital transformation, where we turn
                        your challenges into opportunities. Get your business on height with Kaims IT services.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/img/about-img.jpg" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>

<app-our-client class="about-us-client"></app-our-client>

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>We always try to be the best support to you as possible</h2>
            <p>Qualify your leads & recognize the value of word your customer will love you</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot"></i> Contact Us<span></span></a>
        </div>
    </div>
    <div class="shape10"><img src="assets/img/shape/shape10.png" alt="image"></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt="image"></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt="image"></div>
</section>

<section class="services-area bg-right-shape ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="services-content it-service-content">
                <div class="content left-content">
                    <div class="icon">
                        <img src="assets/img/favicon.png" class="fav-size" alt="image">
                    </div>
                    <h2>Range Of Services We Offer</h2>
                    <!-- <p>Developing a design that is easy to use and navigate your business.</p> -->
                    <div class="row mt-5">
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box d-flex">
                                <i class='bx bxs-badge-check align-self-center me-2'></i>
                                <span class="align-self-center">Web development</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box d-flex">
                                <i class='bx bxs-badge-check align-self-center me-2'></i>
                                <span class="align-self-center">Application Development</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box d-flex">
                                <i class='bx bxs-badge-check align-self-center me-2'></i>
                                <span class="align-self-center">ERP/CMS development</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box d-flex">
                                <i class='bx bxs-badge-check align-self-center me-2'></i>
                                <span class="align-self-center">Software Development</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6">
                            <div class="feature-box d-flex">
                                <i class='bx bxs-badge-check align-self-center me-2'></i>
                                <span class="align-self-center">Digital Marketing/SEO</span>
                            </div>
                        </div>
                    </div>
                    <!-- <a routerLink="/about" class="default-btn"><i class="bx bxs-spreadsheet"></i> Learn
                        More<span></span></a> -->
                </div>
            </div>
            <div class="services-image wow animate__animated animate__fadeInRight" data-wow-delay=".3s">
                <div class="image">
                    <img src="assets/img/services-image/service1.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="feedback-area pt-100 pb-70 bg-f4f6fc">
    <div class="container">
        <div class="section-title">
            <h2>Whats Our Clients Said About <span>Kaims IT Services</span></h2>
        </div>
        <div class="feedback-slides owl-carousel owl-theme">
            <div class="single-feedback-item mt-0">
                <div class="feedback-desc">
                    <p>We are so grateful for such a fantastic design of our business website. Special thanks to the web designers for putting in a lot of effort. They are reliable and result-oriented.</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class='bx bxs-star-half'></i>
                    </div>
                    <div class="client-info">
                        <h3>Oves Jafri</h3>
                        <span>Avis Group Of Company</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item mt-0">
                <div class="feedback-desc">
                    <p>We have been working with Kaims IT for four years to develop a software application to manage our transactional activities of company. The team of software professional is highly responsive and ever ready to solve problems. We are highly delighted and satisfied with their services.</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Hasnain Narasi</h3>
                        <span>Milan Group India</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item mt-0">
                <div class="feedback-desc">
                    <p>The CRM system developed by Kaims IT Service has been a game-changer for our customer relationship and account management. It’s fully customized to our workflow, user-friendly, and integrates seamlessly with our existing platforms. We’ve seen a significant improvement in our customer retention since its implementation!</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Zeeshan Contractor</h3>
                        <span>ZK Tours & Travels</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item mt-0">
                <div class="feedback-desc">
                    <p>Kaims IT Services has been fantastic to work with! They developed my import-export website exactly as I envisioned. The team was professional, attentive, and delivered a high-quality, user-friendly site on time. They understood my business needs perfectly and provided excellent support throughout the process. I’m extremely satisfied with their service and highly recommend them!</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Ali Raza Merchant</h3>
                        <span>Indian Spices pvt ltd</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item mt-0">
                <div class="feedback-desc">
                    <p>Kaims IT Services stands out not just for their strong technical skills but also for their exceptional communication. The team's friendliness shines through, creating a positive experience. Their creative and innovative web designs captivate instantly, showcasing their fantastic and awesome abilities as web designers</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bx-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Chiraj Patel</h3>
                        <span>Taj Park</span>
                    </div>
                </div>
            </div>
            <div class="single-feedback-item mt-0">
                <div class="feedback-desc">
                    <p>Kaims IT proved to be the ideal development partner for my mobile app project. Their expertise, valuable insights, and flexibility made the collaboration seamless. Arun and the team delivered on time, and I'm grateful for their contribution. Best wishes to them for future projects!</p>
                    <div class="rating">
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                        <i class="bx bxs-star"></i>
                    </div>
                    <div class="client-info">
                        <h3>Dr. NurulAbbas Nurani</h3>
                        <span>Bliss linic</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>